import {isNilOrEmpty} from 'ramda-adjunct';

import {FilterValues, SmartSearch, useCreateDataQueryQuery} from '@dms/api/core';

import {convertToSearchParams, OrderByRequestBody} from 'features/datagrid';

export function useDataQuery(
  code: string,
  options?: {
    filters?: FilterValues;
    order?: OrderByRequestBody[];
    smartSearch?: SmartSearch;
  }
) {
  const {data, ...rest} = useCreateDataQueryQuery({
    code,
    createDataQueryRequestBody: {
      filters: options?.filters ?? {},
      order: options?.order ?? [],
      smartSearch: options?.smartSearch ?? null,
    },
  });

  let queryParams: ReturnType<typeof convertToSearchParams> | undefined = undefined;
  if (data?.dataQueryId && !isNilOrEmpty(options)) {
    queryParams = convertToSearchParams({
      dataGrids: {
        gridCode: code,
        queryId: data.dataQueryId,
        rowIndex: '1',
      },
    });
  }

  return {
    gridCode: code,
    dataQueryId: data?.dataQueryId,
    queryParams,
    ...rest,
  };
}
